import '../docs/scss/main.scss'
import { uInput, doubleInput }  from './components/uInput'
import { uSelect, uOption } from './components/select'
import { uCheckbox, checkboxGroup , checkButton} from './components/uCheckbox'
import { uRadio, radioGroup } from './components/uRadio'
import uSwitch from './components/uSwitch'
import { tabBar, omniTab } from './components/tabBar'
import numSpinner from './components/numSpinner'
import treeMenu from './components/treeMenu'
import { uButton, omniButton } from './components/uButton'
import ripple from './components/ripple'
import segmentBar from './components/segmentBar'
import Autocomplete from './components/Autocomplete'
import searchBar from './components/searchBar'
import pagenation from './components/pagenation'
import filterBar from './components/filterBar'
import cardTable from './components/cardTable'
import elasticSideBar from './components/elasticSideBar'
import { editablelist, editableItem } from './components/editablelist'
import textButton from './components/textButton'
import modal from './components/modal'
import toolBar from './components/toolBar'
import formlist from './components/formlist'
import tablelist from './components/tablelist'
import itemlist from './components/itemlist'
import paddleNav from './components/paddleNav'
import couple from './components/couple'
import subsection from './components/subsection'
import uTitle from './components/uTitle'
import uSection from './components/uSection'
import page from './components/page'
import poplist from './components/poplist'
import {timeline, lineItem} from './components/timeline'
import toggleBox from './components/toggleBox'
import Popover from './components/popover';
import DatePicker from './components/date-picker'
import inputNumber from './components/input-number'
import Dropdown from './components/dropdown'
import {Menus, MenuItem} from './components/menu'
import sideLeft from '../docs/components/sideLeft'
import Ftextarea from './components/Ftextarea'
import {Form,FormItem} from './components/form'
import Page from  './components/paging'
import Notify from  './components/notify'
import LoadingBar from  './components/loading-bar'
import { Checkbox, checkGroup } from './components/Checkbox'
import Upload from './components/upload'
import ProgressBar from  './components/progressbar'
import picturePreview from './components/picturePreview'
/*
const install = function (Vue, option) {//
  if (install.installed) return;
  Vue.component(Finput.name, Finput);
  Vue.component(test.name, test);
};
*/



const Fui = {
  uInput,
  uCheckbox,
  checkboxGroup,
  checkButton,
  picturePreview,
  uRadio,
  radioGroup,

  uSwitch,
  tabBar,
  treeMenu,
  uButton,
  Autocomplete,
  ripple,
  segmentBar,
  searchBar,
  pagenation,
  filterBar,
  cardTable,
  elasticSideBar,
  textButton,
  editablelist,
  editableItem,
  uSelect,
  modal,
  toolBar,
  formlist,
  tablelist,
  itemlist,
  paddleNav,
  uOption,
  couple,
  subsection,
  uTitle,
  uSection,
  page,
  poplist,
  omniButton,
  omniTab,
  timeline,
  lineItem,
  doubleInput,
  toggleBox,
  numSpinner,
  Popover,
  DatePicker,
  inputNumber,
  Dropdown,
  Menus, 
  MenuItem,
  sideLeft,
  Ftextarea,
  Form,
  FormItem,
  Page,
  Notify,
  LoadingBar,
  Checkbox, 
  checkGroup,
  Upload,
  ProgressBar
}
Fui.install = (Vue) => {
  for (const componentName in Fui) {
    const component = Fui[componentName]
    if (component && componentName !== 'install') {
      Vue.component(component.name, component)
    }
  }
  Vue.prototype.$notify = Notify;
  Vue.prototype.$LoadingBar = LoadingBar;
}
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default Fui




// WEBPACK FOOTER //
// ./src/index.js